import { Router } from '@angular/router';

/**
 * @deprecated Use Angular router.navigate instead
 *
 * Performs a navigation and adds the given query parameters. Properties of the queryParams
 * object that are undefined or empty strings, are removed.
 *
 * @param router Router instance to get the current query parameters from and that performs the navigation.
 * @param commands The commands of the navigation, e.g. ["/lockers", locker.id].
 * @param queryParams The query parameters that should be added or removed.
 */
export function navigate(router: Router, commands: any[], queryParams: { [key: string]: any }) {
    return new Promise((resolve, reject) => {
        const newQueryParams = { ...router.routerState.snapshot.root.queryParams };
        Object.keys(queryParams).forEach((p) => {
            if (queryParams[p] !== undefined && queryParams[p] !== '') {
                newQueryParams[p] = queryParams[p];
            } else {
                delete newQueryParams[p];
            }
        });
        router.navigate(commands, { queryParams: newQueryParams }).then(resolve).catch(reject);
    });
}
